// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import Import from './Import'
import { Search } from '../../../common/ActionButtons'
import clearPathImportValues from './clearPathImportValues'

const Buttons = ({ highlightedRows, idRoot, sourceForm }) => {
  const dispatch = useDispatch()
  return(
  <div>
    <Search
      idRoot={idRoot} />
    <button
      type={'button'}
      id={'clearValues'}
      className={'btn clear-button big-button display-block margin-bottom-half'}
      onClick={() => dispatch(clearPathImportValues(sourceForm))}>
      {'Clear'}
    </button>
    <Import
      highlightedRows={highlightedRows}
      idRoot={idRoot} />
  </div>
  )
}

Buttons.propTypes = {
  highlightedRows: array.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default Buttons
